export const getExternalGatheringUrl = (externalLink: string): string => {
  return `${window.location.origin}/gathering/lobby/${externalLink}`;
};
